package com.eladfinish.bible.contest.ui.components.toolbar.configuration.model

enum class ToolbarActionPlacement {
    OnToolbar,
    InOverflow,
}
